<script>
    import CodeSelectorManualMBSConsult from "./CodeSelectorManualMBSConsult.svelte";
    import CodeSelectorManualMBSSurgery from "./CodeSelectorManualMBSSurgery.svelte";
    import CodeSelectorManualMBSModifier from "./CodeSelectorManualMBSModifier.svelte";
    import CodeSelectorManualMBSProcedures from "./CodeSelectorManualMBSProcedures.svelte";
    import CodeSelectorManualMBSTime from "./CodeSelectorManualMBSTime.svelte";
    import CodeSelectorManualMBSClaimDelayHoursAndInvoiceCustomDueDate from "./CodeSelectorManualMBSClaimDelayHoursAndInvoiceCustomDueDate.svelte";

    import { hasCardiacMbsCode } from "../../../helpers/mbsHelper.svelte";

    export let itemProps = {},
        doctorId = 0,
        procedureName = "",
        selectedItems = [],
        holidaysInState = [],
        infoTypesMap = new Map(),
        updateItems = () => {},
        openNotification = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: showSurgerySection =
        itemProps.billingType == 0 ||
        (isCardiacEncounter &&
            hasCardiacMbsCode(selectedItems) &&
            selectedItems.some((item) =>
                [17610, 17615, 17620, 17625].includes(item.itemNum),
            ));

    $: showModifierSection =
        itemProps.billingType == 0 ||
        (isCardiacEncounter &&
            hasCardiacMbsCode(selectedItems) &&
            selectedItems.some((item) =>
                [17610, 17615, 17620, 17625, 22060].includes(item.itemNum),
            ));

    $: showAdditionalProcedureSection =
        (isCardiacEncounter &&
            hasCardiacMbsCode(selectedItems) &&
            selectedItems.some((item) =>
                [17610, 17615, 17620, 17625, 22060].includes(item.itemNum),
            )) ||
        (!isCardiacEncounter &&
            !selectedItems.some((item) =>
                specialItemAffectProcedures.includes(item.itemNum),
            ));

    // Hide time selector for billing type "Consults & Attendances"
    $: showTimeSection =
        itemProps.billingType == 0 ||
        itemProps.billingType == 2 ||
        (isCardiacEncounter &&
            hasCardiacMbsCode(selectedItems) &&
            selectedItems.some((item) =>
                [17610, 17615, 17620, 17625, 22060].includes(item.itemNum),
            ));

    // For Item Time Selector
    export let timeObj = {};

    let procedureRef;

    const specialItemAffectProcedures = [92701];

    // HELPER FUNCTIONS
</script>

<div class="flex flex-1 flex-col gap-y-4 overflow-y-auto p-4">
    <div class="flex flex-1 gap-x-4">
        <div class="flex flex-col flex-1 gap-y-4">
            <CodeSelectorManualMBSConsult
                {itemProps}
                defaultItems={infoTypesMap.get("Consults")}
                {selectedItems}
                {updateItems}
            />

            {#if showSurgerySection}
                <CodeSelectorManualMBSSurgery
                    {itemProps}
                    {doctorId}
                    {procedureName}
                    defaultItems={infoTypesMap.get("Surgery")}
                    timeItems={infoTypesMap.get("Time")}
                    {selectedItems}
                    {updateItems}
                />
            {/if}
        </div>

        <div class="flex flex-col flex-1 gap-y-4">
            {#if showModifierSection}
                <CodeSelectorManualMBSModifier
                    {itemProps}
                    defaultItems={infoTypesMap.get("Modifiers")}
                    {selectedItems}
                    {updateItems}
                />
            {/if}

            {#if showAdditionalProcedureSection}
                <CodeSelectorManualMBSProcedures
                    bind:this={procedureRef}
                    bind:itemProps
                    defaultItems={infoTypesMap.get("AdditionalProcedures")}
                    {selectedItems}
                    {holidaysInState}
                    {updateItems}
                    {openNotification}
                />
            {/if}
        </div>
    </div>

    {#if showTimeSection}
        <CodeSelectorManualMBSTime
            bind:timeObj
            bind:itemProps
            {procedureRef}
            {selectedItems}
            defaultItems={infoTypesMap.get("Time")}
            {updateItems}
        />
    {/if}

   <!--  {#if itemProps.showClaimDelayHoursAndInvoiceCustomDueDate}
        <CodeSelectorManualMBSClaimDelayHoursAndInvoiceCustomDueDate
            bind:itemProps
        />
    {/if} -->
</div>
